export default "__VITE_ASSET__1d5eeb84__"